export const viewTitle = "Список описей дел";
export const viewUniqKey = "ERCProtocolsView";
